import AppDispatcher from '../utils/AppDispatcher';

import { actions as ActionTypes } from '../constants/RoutingConstants';

export default {
    updateRoute:(url) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.UPDATE_ROUTE,
            url: url
        });
    },
    closeProfile:() => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.CLOSE_PROFILE
        });
    },
    back:() => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.BACK
        });
    }
}



// WEBPACK FOOTER //
// ./ui_src/app/actions/RoutingActions.jsx